import { GET_GAME_HISTORY, GET_GAME_STATS, RESET_COIN } from "./type";

const initialState = {
  gameHistory: [],
  pagination: {
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 1
  },
  gameStats: {
    totalGames: 0,
    totalDiamondsSpent: 0,
    totalDiamondsWon: 0,
    houseProfit: 0
  },
  adminCoin: 0,
};

export const gameHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_GAME_HISTORY:
      return {
        ...state,
        gameHistory: action.payload.history || [],
        pagination: action.payload.pagination || state.pagination,
      };
    case GET_GAME_STATS:
      return {
        ...state,
        gameStats: {
          ...state.gameStats,
          ...action.payload
        },
      };
    case RESET_COIN:
      return {
        ...state,
        gameStats: {
          ...state.gameStats,
          adminCoin: action.payload,
        },
      };
    default:
      return state;
  }
};
